import React, { useState } from "react"
import { PricingCalculatorComponent } from "../../components/PricingCalculator"
import { IN_CONFIG } from "../../utils/PricingUtils"
import { PasswordScreen } from "../../components/PasswordScreen"
import Layout from "../../components/Layout"
import Header from "../../components/Header"

export function Index() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)

  if (!isAuthenticated) {
    return <PasswordScreen onSuccess={() => setIsAuthenticated(true)} />
  }

  return (
    <Layout
      title="Premagic Pricing India - AI Event Platform Plans"
      description="Affordable AI event platform pricing for India. Transparent plans for conferences, corporates & trade shows. Start free trial."
      keywords={[
        "Premagic pricing India, AI event platform cost, event technology pricing India, conference platform pricing, corporate event pricing, Indian event platform rates, photo sharing pricing India, networking platform cost, enterprise event pricing, MICE platform pricing, event management pricing, conference technology rates, Indian market pricing, affordable event platform, event AI pricing India",
      ]}
    >
      <Header />
      <PricingCalculatorComponent config={IN_CONFIG} />
    </Layout>
  )
}

export default Index
